/**
 * Site identity store — the per-site `site` object of the site entity.
 *
 * One entry per loaded site, keyed by site id, holding the site object from
 * the composite retrieve (name, owner, weather, location, billboard flags, …).
 * Seeded by the retrieve fan-out (endpoints.js → ingestSiteSnapshot) and
 * replaced wholesale by the `site` socket event. This is the normalized home
 * cross-route readers (LeftNav, the billboard image rail) read site context
 * from, so it never evicts.
 *
 * Contains:
 * - site slice (replaceSite) + reducer (default export)
 */
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'site',
  initialState: { bySiteId: {} },
  reducers: {
    /** Full-replace a site's identity object (retrieve or `site` socket event). */
    replaceSite(state, action) {
      const { siteId, site } = action.payload;
      state.bySiteId[String(siteId)] = site;
    },
  },
});

export const { replaceSite } = slice.actions;
export default slice.reducer;
